import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import Tooltipable from "~/components/effects/tooltipable";
import EmailDomainRecords from "./EmailDomainRecords";

const EmailDomainRecordSection = ({
  title,
  description,
  required = false,
  domain,
  records,
  receiving = false,
  spfTooltip = false,
  children,
}) => {
  return (
    <section aria-label={title}>
      <h4 className="px-4 pt-3">
        {title}{" "}
        <span className="h6 text-gray">
          ({required ? "Required" : "Optional"})
        </span>
        <Tooltipable
          trigger="click"
          placement="right"
          text={
            <>
              {description}
              <br />
              You will need to add the following DNS records to the account
              where you manage DNS (such as{" "}
              <a
                className="text-green"
                href="https://godaddy.com/help/manage-dns-records-680"
                target="_blank"
                rel="noopener noreferrer"
              >
                GoDaddy
              </a>
              ).
            </>
          }
        >
          <FontAwesomeIcon
            icon="fad fa-info-circle"
            style={{ "--fa-primary-color": "white" }}
            className="ml-2"
            size="xs"
          />
        </Tooltipable>
      </h4>
      <EmailDomainRecords
        domain={domain}
        records={records}
        receiving={receiving}
        spfTooltip={spfTooltip}
      />
      {children}
    </section>
  );
};
EmailDomainRecordSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  required: PropTypes.bool,
  domain: PropTypes.object.isRequired,
  records: PropTypes.arrayOf(PropTypes.object),
  receiving: PropTypes.bool,
  spfTooltip: PropTypes.bool,
  children: PropTypes.node,
};

export default EmailDomainRecordSection;
